import { apiClient } from './_shared.js'

export async function getSupportTickets() {
  const data = await apiClient('/support/tickets')
  return data.tickets || []
}

export async function createSupportTicket(ticketData) {
  return await apiClient('/support/tickets', {
    method: 'POST',
    body: JSON.stringify(ticketData),
  })
}

export async function getSupportTicketDetails(ticketId) {
  return await apiClient(`/support/tickets/${ticketId}`)
}

export async function sendSupportTicketMessage(ticketId, messageData) {
  return await apiClient(`/support/tickets/${ticketId}/messages`, {
    method: 'POST',
    body: JSON.stringify(messageData),
  })
}

export async function updateSupportTicketStatus(ticketId, status) {
  return await apiClient(`/support/tickets/${ticketId}/status`, {
    method: 'PUT',
    body: JSON.stringify({ status }),
  })
}
